import PropTypes from "prop-types";
import ImageHelper from '../../../../../../../../utilities/helpers/ImageHelper';
import logo from '../../../../../../../../assets/images/experience_balnk.svg';
import { useDictionary } from "../../../../../../../../utilities/hooks/UseDictionary";

const PoiExperienceItem = ({experience, onItemCLicked}) => {
    const dictionary = useDictionary();


    return (
        <tr
			className="slot-booking-container"
			key={experience.id}
			onClick={() => onItemCLicked(experience)}
		>
            {/*<td>*/}
            {/*    <div className="booking-number">*/}
            {/*        {experience.title}*/}
            {/*    </div>*/}
            {/*</td>*/}
            <td>
                <div className="d-flex-center custom-experience-container">
                    <div className="custom-experience-image-container">
                        <img
                            onError={(e) => {
                                e.currentTarget.src = logo;
                            }}
                            src={experience?.thumbnail_url ? ImageHelper.getFullImageUrl(experience?.thumbnail_url) : logo}
                            className="custom-experience-image"
                        />
                    </div>
                    <div className="custom-experience-title truncate" title={experience?.title}>
                        {experience?.title}
                    </div>
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(experience.relation_type) ?? '-'}
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(experience.gttd_relation_type) ?? '-'}
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(experience.feed_id) ? experience.feed_id : '-'}
                </div>
            </td>
        </tr>
    )
            
}

PoiExperienceItem.propTypes = {
  experience: PropTypes.object,
  onItemCLicked: PropTypes.func
};

export default PoiExperienceItem;